import React from 'react';
import {
  FaPhone, FaEnvelope, FaClock, FaGlobe,
  FaMapMarkerAlt, FaCheckCircle
} from 'react-icons/fa';
import ContactForm from '../components/ContactForm';
import PhoneCTA from '../components/PhoneCTA';
import { CONTACT, phoneHref } from '../constants/contact';
import './ContactUs.css';

const contactDetails = [
  {
    icon: FaPhone,
    title: 'Phone',
    lines: [
      { type: 'link', href: phoneHref, text: CONTACT.phone },
    ],
    note: 'Speak with a parts specialist',
  },
  {
    icon: FaEnvelope,
    title: 'Email',
    lines: [
      { type: 'link', href: `mailto:${CONTACT.email}`, text: CONTACT.email },
    ],
    note: 'We reply within 24 hours',
  },
  {
    icon: FaMapMarkerAlt,
    title: 'Address',
    lines: [
      { type: 'text', text: CONTACT.company },
      { type: 'text', text: CONTACT.addressLine1 },
      { type: 'text', text: CONTACT.addressLine2 },
    ],
    note: 'Nodex Global LLC headquarters',
  },
  {
    icon: FaGlobe,
    title: 'Website',
    lines: [
      { type: 'link', href: CONTACT.websiteUrl, text: CONTACT.website, external: true },
    ],
    note: 'Browse our full catalog',
  },
  {
    icon: FaClock,
    title: 'Business Hours',
    lines: [
      { type: 'text', text: 'Mon–Fri: 8:00 AM – 8:00 PM EST' },
      { type: 'text', text: 'Sat: 9:00 AM – 5:00 PM EST' },
      { type: 'text', text: 'Sun: Closed' },
    ],
  },
];

const perks = [
  'Free part lookup & fitment check',
  'Quotes within 24 business hours',
  'Nationwide shipping available',
  '90-day warranty on all parts',
];

const ContactUs = () => {
  return (
    <main className="contact-page">
      <section className="contact-hero">
        <div className="container contact-hero-inner">
          <span className="contact-hero-badge">GET IN TOUCH</span>
          <h1>Contact Us</h1>
          <p>
            Have a question about a part, order, or fitment? Our team at{' '}
            <strong>NX Auto Care</strong> is ready to help you find the right OEM part at the best price.
          </p>
        </div>
      </section>

      <section className="contact-main">
        <div className="container contact-main-grid">
          <div className="contact-info-col">
            <h2>We&apos;re Here to Help</h2>
            <p className="contact-info-lead">
              Reach out by phone, email, or the form — whichever works best for you.
              {CONTACT.company} powers NX Auto Care with expert support 6 days a week.
            </p>

            <div className="contact-cards">
              {contactDetails.map(({ icon: Icon, title, lines, note }) => (
                <div className="contact-card" key={title}>
                  <div className="contact-card-icon">
                    <Icon />
                  </div>
                  <div>
                    <h3>{title}</h3>
                    {lines.map((line, i) =>
                      line.type === 'link' ? (
                        <a
                          key={i}
                          href={line.href}
                          target={line.external ? '_blank' : undefined}
                          rel={line.external ? 'noreferrer' : undefined}
                        >
                          {line.text}
                        </a>
                      ) : (
                        <span key={i}>{line.text}</span>
                      )
                    )}
                    {note && <p className="contact-card-note">{note}</p>}
                  </div>
                </div>
              ))}
            </div>

            <div className="contact-perks">
              {perks.map((perk) => (
                <div className="contact-perk" key={perk}>
                  <FaCheckCircle />
                  <span>{perk}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="contact-form-col">
            <ContactForm />
          </div>
        </div>
      </section>

      <section className="contact-cta-bar">
        <div className="container contact-cta-bar-inner">
          <div>
            <FaMapMarkerAlt className="contact-cta-icon" />
            <div>
              <strong>Need parts fast?</strong>
              <span>Call now for same-day quotes on in-stock items.</span>
            </div>
          </div>
          <PhoneCTA variant="bar" showNumber={false} label="Call Now" />
        </div>
      </section>
    </main>
  );
};

export default ContactUs;
